export const MARKETING_THEME_TOKEN_NAMES = [
  "--marketing-canvas",
  "--marketing-surface",
  "--marketing-surface-muted",
  "--marketing-text",
  "--marketing-muted",
  "--marketing-accent",
  "--marketing-accent-strong",
  "--marketing-accent-soft",
  "--marketing-border",
  "--marketing-border-strong",
  "--marketing-focus",
  "--font-marketing-body",
  "--font-marketing-display",
] as const;

export type MarketingThemeTokenName = (typeof MARKETING_THEME_TOKEN_NAMES)[number];
export type MarketingTheme = Record<MarketingThemeTokenName, string>;

const MARKETING_THEME_TOKEN_SET = new Set<string>(MARKETING_THEME_TOKEN_NAMES);
const UNSAFE_THEME_VALUE_PATTERN = /[{};<>]/;

export function isMarketingThemeTokenName(value: string): value is MarketingThemeTokenName {
  return MARKETING_THEME_TOKEN_SET.has(value);
}

export function assertMarketingTheme(
  theme: Partial<Record<string, string>> | undefined,
  context = "persona theme",
): asserts theme is Partial<MarketingTheme> | undefined {
  if (!theme) {
    return;
  }

  for (const [token, value] of Object.entries(theme)) {
    if (!isMarketingThemeTokenName(token)) {
      throw new Error(`${context} uses unsupported token "${token}".`);
    }

    if (typeof value !== "string" || value.trim().length === 0 || UNSAFE_THEME_VALUE_PATTERN.test(value)) {
      throw new Error(`${context} has an unsafe value for "${token}".`);
    }
  }
}
